export default __webpack_public_path__ + "static/media/facebook.3064e903.svg";